interface Props {
  /** Tailwind-friendly size in px. Defaults to 16. */
  size?: number
  /** Stroke color (hex or CSS var). Defaults to muted grey. */
  color?: string
  /** Extra classes — animations, rotations, opacity. */
  className?: string
}

/**
 * A single → chevron used anywhere a row hints at tappable navigation or
 * an expandable section (rotate 90° on open).
 */
export function ChevronRight({ size = 16, color = '#6B7280', className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M9 18l6-6-6-6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
